var _line, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.86621,
    y1: 4.46152,
    x2: 15.1338,
    y2: 4.46152,
    stroke: "#444444",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.27326 4.27273L8.27326 2.5L9.72852 2.5L9.72852 4.27273L8.27326 4.27273Z",
    fill: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78613 5.06152V13.6134C4.78613 14.1657 5.23385 14.6134 5.78613 14.6134H12.2142C12.7665 14.6134 13.2142 14.1657 13.2142 13.6134V5.06152",
    stroke: "#444444",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00996 11.8062L7.00996 7.34119L8.20996 7.34119L8.20996 11.8062L7.00996 11.8062Z",
    fill: "#444444"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79121 11.8062L9.79121 7.34119L10.9912 7.34119L10.9912 11.8062L9.79121 11.8062Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.20ecc46d32e9338e42522fcc9c263747.svg";
export { ForwardRef as ReactComponent };